import { useContext, useRef, useEffect } from "react";
import { preventClickOutsideContext } from "../components/SidePanel";
import { useHistory } from "react-router-dom";

export default function usePreventExit(preventExit = false) {
  const history = useHistory();
  const ref = useRef({});
  const context = useContext(preventClickOutsideContext);

  if (preventExit) ref.current = true;

  useEffect(() => {
    if (!context) return;

    const { preventClickOutsideSet, setPreventClickOutsideSet } = context;
    const exists = preventClickOutsideSet.has(ref.current);

    if (exists && !preventExit) {
      setPreventClickOutsideSet((set) => {
        // is preventing and shouldn't
        const newSet = new Set(set);
        newSet.delete(ref.current);
        return newSet;
      });
    } else if (!exists && preventExit) {
      // is not preventing and should
      setPreventClickOutsideSet((set) => {
        const newSet = new Set(set);
        newSet.add(ref.current);
        return newSet;
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preventExit]);

  useEffect(() => {
    if (!preventExit || window.onbeforeunload) return;
    window.onbeforeunload = () =>
      "You have unsaved changes. Are you sure you would like to close Skipio?";
    return () => {
      window.onbeforeunload = null;
    };
  }, [preventExit]);

  useEffect(() => {
    if (!preventExit) return;

    const unblock = history.block(() => {
      return "You have unsaved changes. Are you sure you would like to leave this page?";
    });

    return () => {
      unblock();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preventExit]);
}
